import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import {Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

import {GridModel} from '../../shared/grid/grid.model';
import {LoaderService} from '../../services/loader.service';
import {ToastService} from '../../services/toast.service';
import {User} from '../../models/user.model';
import {UserService} from '../../services/user.service';

@Component({
  standalone: false,
  selector: 'app-workforce-table',
  templateUrl: './workforce-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./workforce-table.component.scss']
})
export class WorkforceTableComponent implements OnInit {

  itemsPerPage = 10;
  p = 1;
  selectedWorkforceData: any;
  workforceInfoOpen = false;
  workforceData: GridModel<User>;
  @Output() hideModal = new EventEmitter<boolean>();
  filterValue: string;

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private toastService: ToastService) {
    this.filterValue = '';
  }

  ngOnInit(): void {
    this.loadUsers();
  }


  selectWorkforce(data) {
    this.selectedWorkforceData = data;
    this.workforceInfoOpen = true;
  }

  hideView() {
    this.workforceInfoOpen = false;
    this.hideModal.emit(true);
    this.loadUsers();
  }

  private loadUsers() {
    this.loaderService.show();
    this.userService.get(this.filterValue, '', '', this.p - 1, this.itemsPerPage, '').subscribe(result => {
        this.workforceData = result;
        this.loaderService.hide();
      },
      error => {
        this.toastService.showError('Error loading data!');
        this.loaderService.hide();
      });
  }

  onPageChange($event: number) {
    this.p = $event;
    this.loadUsers();
  }

    public trackByIndex = trackByIndex;
}
